module.exports = __webpack_public_path__ + "media/newstyle/images/icon-cross-red-920da8d5dae4c53b331fb26ecc158606.svg";